import { Popover, PopoverProps } from '@material-ui/core';
import cx from 'classnames';
import React from 'react';

import { List, ListItem, ListItemTitle } from '@ds';
import { useUpdateUserSettingsMutation } from '@shared/api';
import { APPLICATION_TYPE } from '@shared/constants';
import { useActiveWorkspaceName } from '@shared/hooks';
import { redirectToLLM } from '@shared/utils';
import { useHistory } from 'react-router';

import styles from './AppMenu.module.scss';

type AppMenuProps = PopoverProps & {
  onClose: () => void;
};

const AppMenu = (menuProps: AppMenuProps) => {
  const history = useHistory();
  const currentWorkspaceName = useActiveWorkspaceName();
  const updateUserSettingsMutation = useUpdateUserSettingsMutation();

  const handleAppChange = async (appName: APPLICATION_TYPE) => {
    try {
      await updateUserSettingsMutation.mutateAsync({
        updates: { userAppType: appName }
      });
    } finally {
      if (appName === APPLICATION_TYPE.llm) {
        redirectToLLM(currentWorkspaceName);
      } else {
        history.push(`/${currentWorkspaceName}`);
      }
    }
    menuProps.onClose();
  };

  return (
    <Popover
      data-test="app-menu"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      PaperProps={{
        className: styles.popoverContainer
      }}
      transitionDuration={0}
      elevation={0}
      {...menuProps}
    >
      <List>
        <ListItemTitle text="Your apps" />

        <ListItem onClick={() => handleAppChange(APPLICATION_TYPE.em)}>
          <ListItem.PrefixContainer>
            <div className={cx(styles.appIcon, styles.emIcon)}>EM</div>
          </ListItem.PrefixContainer>
          <ListItem.Text primary="Experiment management" />
        </ListItem>

        <ListItem onClick={() => handleAppChange(APPLICATION_TYPE.llm)}>
          <ListItem.PrefixContainer>
            <div className={cx(styles.appIcon, styles.llmIcon)}>LLM</div>
          </ListItem.PrefixContainer>
          <ListItem.Text primary="LLM evaluation (Opik)" />
        </ListItem>
      </List>
    </Popover>
  );
};

export default AppMenu;
